import Login from "../Login";
import PublicWorkOrders from "../components/PublicWorkOrders";
import PublicPropertyReviews from "../components/PublicPropertyReviews";
import UserRegistration from "../components/UserRegistration";
import PublicIssueView from "../components/PublicIssueView";
import PrivacyPolicy from "../components/PrivacyPolicy";
import TermsAndConditions from "../components/TermsAndConditions";

export const publicRoutes = [
  { path: "/", component: Login },
  { path: "/login", component: Login },
  { path: "/workorder", component: PublicWorkOrders },
  { path: "/reviews", component: PublicPropertyReviews },
  { path: "/register", component: UserRegistration },
  { path: "/issues/:issueId", component: PublicIssueView },
  { path: "/privacy-policy", component: PrivacyPolicy },
  { path: "/terms", component: TermsAndConditions },
];
